





































































































import {Component, Prop, Watch} from 'vue-property-decorator';
import {Getter} from 'vuex-class';

import * as Types from '../interfaces/Menu-Innovorder';
import BaseProduct from './BaseProduct.vue';
import ModalProduct from './ModalProduct.vue';

@Component({
  components: {
    ModalProduct,
  },
})
export default class ProductCard extends BaseProduct {
  @Prop() readonly product!: Types.Product;

  @Getter('enableFeedback', {namespace: 'site'}) enableFeedback!: boolean;

  @Watch('$route.hash')
  updateDialog(newHash: string, oldHash: string): void {
    if (newHash === `#${this.product.name}`) {
      this.dialog = true;
    } else if (oldHash === `#${this.product.name}`) {
      this.dialog = false;
    }
  }

  dialog = false;
}
